<template>
  <div class="ccui-app-container-detail2">
    <div class="ccui-app-container-detail-body">
      <div style="margin-bottom:10px" v-if="isPassFlag">
        <!-- 淘汰 已不能查看 -->
        <el-alert
          class="alertColor"
          :title="$t('page.content.UnableSee')"
          type="warning"
          :closable="false"
          show-icon
        >
        </el-alert>
      </div>
      <div v-else>
        <div style="margin-bottom:10px" v-if="flag == 1">
          <!-- 尙未开标，不能查看投标一览表 -->
          <el-alert
            class="alertColor"
            :title="$t('page.content.openning')"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>
        </div>
        <div style="margin-bottom:10px" v-if="flag == 2">
          <!-- 您未投标，不能查看开标一览表 -->
          <el-alert
            class="alertColor"
            :title="$t('page.content.opening1')"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>
        </div>
        <!-- 该环节已经结束 -->
        <div style="margin-bottom:10px" v-if="flag == 4">
          <el-alert
            class="alertColor"
            :title="$t('page.content.closed')"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>
        </div>
        <!--该环节已结束 -->
        <div style="margin-bottom:10px" v-if="flag == 999">
          <el-alert
            class="alertColor"
            :title="$t('page.content.closed')"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>
        </div>
        <!-- 已投标 其他类型 -->
        <div
          class="noBuy"
          v-if="flag == 3 && purchaseType != 50 && purchaseType != 53"
        >
          <div
            class="tableDetail"
            v-for="(item, index) in tableData"
            :key="index"
          >
            <div class="top">
              <span class="name" :title="item.packName">{{
                item.packName
              }}</span>
            </div>
            <!-- <hr style="border:1px solid #EDF2FC;width:100%" /> -->
            <div class="footer">
              <div class="tableBox">
                <el-table :data="item.sscSupIsBidPriceBOS" border>
                  <!-- 序号 -->
                  <el-table-column
                    type="index"
                    :label="$t('page.content.No')"
                    width="55"
                    align="center"
                  />
                  <!-- 供应商名称 -->
                  <el-table-column
                    prop="supName"
                    :label="$t('page.content.Supplier')"
                    min-width="100"
                  ></el-table-column>
                  <!-- 投标金额（元） -->

                  <el-table-column
                    prop="priceAmountStr"
                    :label="`${$t('page.content.bidAmount')}(${unit})`"
                    width="200"
                    header-align="left"
                    align="right"
                  >
                    <template slot-scope="{ row }">
                      <span> {{ row.priceAmountStr }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <!-- 协议类型 -->
        <div v-if="(flag == 3 && purchaseType == 50) || purchaseType == 53">
          <el-group-title :title="$t('page.content.Summary')">
            <template slot="groupTitle">
              <div class="tip">
                <!-- 公告内容： -->
                <!-- {{ $t("page.content.Content") }} -->
                <p class="title">
                  <span
                    class="titleName rich-text"
                    v-html="sscNoticeBO.textInfo"
                  ></span>
                </p>
              </div>
            </template>
          </el-group-title>
          <!-- 附件列表 -->
          <detailBaseTable
            :title="$t('page.content.Attachments')"
            :table-head="tableChangeHistoryHead"
            :table-data="tableChangeHistoryData"
          >
            <!-- 操作 -->
            <template
              :slot="$t('page.content.operation')"
              slot-scope="{ row, $index }"
            >
              <el-button
                size="mini"
                type="text"
                @click="downloadUrlFile(row, $index)"
              >
                <!-- 下载 -->
                {{ $t("page.content.Download") }}
              </el-button>
              <!-- 预览 -->
              <el-button size="mini" type="text" @click="preview(row)">
                {{ $t("page.content.Yulan") }}
              </el-button>
            </template>
          </detailBaseTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPreviewUrl } from "@/basa/utils";
import {
  qrySupBidOpenDetail,
  qryBidOpenViewCheck,
  qryNoticeDetail,
  qrySupPreqtion,
  queryPurchaseSchemeDetail,
  qryBidSchemeProcessStatus
} from "@/app/myProjects/api/myProjects.js";
import { addUrlPerFix } from "@/basa/utils";
import BigNumber from "bignumber.js";
export default {
  components: {},
  async mounted() {
    this.purchaseType = sessionStorage.getItem("purchaseType");
    this.agentId = this.$router.history.current.query.a;
    this.schemeId = sessionStorage.getItem("schemeId");
    this.supCode = sessionStorage.getItem("supCode");
    this.supName = sessionStorage.getItem("supName");

    let params = {
      schemeId: this.schemeId,
      supCode: this.supCode,
      agentId: this.agentId,
      isShowPageLoading: true
    };
    let res = (await qrySupPreqtion(params)).data.data;
    let eliminateObj = res.sscSupPreqtionBO;
    if (eliminateObj == null) {
      this.isPassFlag = false;
    } else {
      let eliminate = res.sscSupPreqtionBO.passFlag;
      let preStatus = res.sscSupPreqtionBO.preStatus; // =2 表示资格审定已经结束
      this.isPassFlag =
        eliminate === "0" || (eliminate === "" && preStatus === "2");
    }

    if (!this.isPassFlag) {
      this.qryBidOpenViewCheck();
      this.queryPurchaseSchemeDetail();
    }
  },
  data() {
    return {
      purchaseType: "", //协议类型
      agentId: "",
      schemeId: sessionStorage.getItem("schemeId"),
      supCode: sessionStorage.getItem("supCode"),
      supName: sessionStorage.getItem("supName"),
      flag: "", //1 未开始 2 未投标 3已投标 4已结束
      tableDownloadData: [],
      tableUpData: [],
      tableBid: [],
      dialogTableVisibletextarea: false,
      tableData: [],
      // 协议类
      sscNoticeBO: {
        textInfo: ""
      },
      tableChangeHistoryData: [],
      // 附件列表
      tableChangeHistoryHead: [
        { label: this.$t("page.content.name"), prop: "fileName" }, //附件名称
        { label: this.$t("page.content.Description"), prop: "fileSumm" }, //附件说明
        {
          label: this.$t("page.content.operation"),
          prop: "option",
          slot: this.$t("page.content.operation"),
          width: "100"
        } //操作
      ],
      isPassFlag: false, //1：通过 0或者空：淘汰
      unit: ""
    };
  },
  methods: {
    queryPurchaseSchemeDetail() {
      queryPurchaseSchemeDetail({
        schemeId: this.schemeId,
        agentId: this.$router.history.current.query.a, //后期菜单获取
        isShowPageLoading: true
      }).then(res => {
        if (res) {
          this.unit = res.data.data.unit; //币种
        }
      });
    },
    async qryBidOpenViewCheck() {
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { agentId: this.agentId },
        { supCode: this.supCode },
        { purStep: "9" }, // 9是定标
        { isShowPageLoading: true }
      );
      let bidSchemeProcessStatus = (await qryBidSchemeProcessStatus(param)).data
        .data;
      if (
        bidSchemeProcessStatus.billStatus === "3" &&
        bidSchemeProcessStatus.exeStatus === "1"
      ) {
        this.flag = "999"; //定标完成 不能查看投标一览
      } else {
        qryBidOpenViewCheck(param).then(res => {
          if (res) {
            this.flag = res.data.data.checkFlag;
            let obj = {
              isShowexeTime: false,
              isShowTag: false,
              isShowLeftTime: false,
              isShowCouTime: false
            };
            this.$store.commit("edit", obj);
            if (this.flag == 3) {
              this.getSupBidOpenTotalDetail();
              if (this.purchaseType == 50 || this.purchaseType == 53) {
                this.getNoticeDetail();
              }
            }
          }
        });
      }
    },
    getSupBidOpenTotalDetail() {
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { agentId: this.agentId },
        { purStep: "6" } //寻源环节
      );
      qrySupBidOpenDetail(param).then(res => {
        if (res) {
          let data = res.data.data;
          let supName = sessionStorage.getItem("supName");
          data.forEach(e => {
            e.sscSupIsBidPriceBOS.forEach(f => {
              if (f.supName == supName && f.priceAmountStr !== "") {
                e.isShow = 1;
              }
              f.priceAmountStr =
                f.priceAmountStr === ""
                  ? ""
                  : new BigNumber(f.priceAmountStr || 0).toFormat(2);
            });
          });
          let data1 = data.filter(m => m.isShow == 1);
          this.tableData = data1;
          //包件供应商都没报价的话不展示--已改为后端处理
          // let data2 = data1.filter(n => {
          //   let filter1 = n.sscSupIsBidPriceBOS.filter(g => g.priceAmountStr !== "")
          //   return filter1.length > 0
          // })
          // this.tableData = data2;
        }
      });
    },
    //公告详情
    getNoticeDetail() {
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { agentId: this.agentId },
        { purStep: this.$route_query.purStep },
        { qryFileFlag: true }
      );
      qryNoticeDetail(param).then(res => {
        if (res.data.data) {
          this.sscNoticeBO = res.data.data;
          this.tableChangeHistoryData = this.sscNoticeBO.fileinfoBOS;
        }
      });
    },
    // 下载含有url的文件
    downloadUrlFile(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid/oss/downloadByUploadId?fileUrl=${
        row.fileUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
      console.log(openUrl.href, "nn");
    },
    //预览
    preview({ fileUrl }) {
      getPreviewUrl(fileUrl);
      //const previewSrc = getPreviewUrl(fileUrl);
      //window.open(previewSrc);
    }
  }
};
</script>

<style lang="scss" scoped>
.noBegin {
  display: flex;
  justify-content: center;
  height: 500px;
  align-items: center;
  font-size: 18px;
  color: #4a4a4a;
}
.tableDetail {
  margin-top: 10px;
  padding-bottom: 10px;
  border: 1px solid #edf2fc;
  .top {
    padding: 0px 10px;
    color: #4a4a4a;
    height: 40px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #edf2fc;
    .name {
      padding-right: 20px;
      font-size: 14px;
    }
  }
  .center {
    padding: 10px 10px;
    color: #4a4a4a;
    font-size: 14px;
  }
  .footer {
    padding: 10px 10px;
    color: #4a4a4a;
    font-size: 14px;
    .chlidName {
      padding-bottom: 10px;
    }
    .tableBox {
      padding: 0px 20px;
    }
  }
}
/deep/.el-table__row {
  line-height: 36px;
  height: 36px;
}
</style>
